const AUTH_REGISTRATION_SCHEMA = schema.object({
  email: schema
    .string({
      required_error: localeValidation().required,
    })
    .email({
      message: localeValidation().email,
    }),
  password: schema
    .string({
      required_error: localeValidation().required,
    })
    .min(8, {
      message: localeStringReplacement(localeValidation().lengthMin, {
        items: localeValidation().characters,
        length: "8",
      }),
    }),
  termsAccepted: schema
    .boolean({
      required_error: localeValidation().termsAccepted,
    })
    .refine(
      (value) => {
        return value;
      },
      {
        message: localeValidation().termsAccepted,
      },
    ),
  fromEmail: schema.boolean().optional(), // Делаем поле опциональным
});

type AuthRegistrationFields = FormFields<AuthRegistrationSchemaInfer>;

type AuthRegistrationForm = RegistrationPayload & { termsAccepted: boolean; fromEmail?: boolean };

type AuthRegistrationSchemaInfer = SchemaInfer<typeof AUTH_REGISTRATION_SCHEMA>;

export { AUTH_REGISTRATION_SCHEMA };
export type { AuthRegistrationFields, AuthRegistrationForm };
